import {
  CHECKOUT_HOTEL_SUCCESS,
  CHECKOUT_GIFT_SUCCESS,
  CHECKOUT_PASS_SUCCESS,
  SEGMENT_REQUEST,
  OPEN_CHECKOUT_ITEM_PAGE,
  OPEN_CHECKOUT_GIFT_PAGE,
  OPEN_CHECKOUT_SUBSCRIPTION_PAGE,
  OPEN_SEARCH_PAGE,
  OPEN_PRODUCT_PAGE,
} from '../types';

export const sendCheckoutHotelDataToAnalytics = payload => ({ type: CHECKOUT_HOTEL_SUCCESS, payload });

export const sendCheckoutGiftDataToAnalytics = payload => ({ type: CHECKOUT_GIFT_SUCCESS, payload });

export const sendCheckoutPassDataToAnalytics = payload => ({ type: CHECKOUT_PASS_SUCCESS, payload });

export const reportToSegmentAction = (type, name, properties = {}, options = {}) => ({ type: SEGMENT_REQUEST, payload: { type, name, properties, options } });

export const onCheckoutItemPageOpen = () => ({ type: OPEN_CHECKOUT_ITEM_PAGE });

export const onCheckoutGiftPageOpen = () => ({ type: OPEN_CHECKOUT_GIFT_PAGE });

export const onCheckoutSubscriptionPageOpen = (name, type, id, guests, price, image) => ({ type: OPEN_CHECKOUT_SUBSCRIPTION_PAGE, payload: { name, type, id, guests, price, image } });

export const onSearchPageOpen = () => ({ type: OPEN_SEARCH_PAGE });

export const onProductPagePageOpen = () => ({ type: OPEN_PRODUCT_PAGE });
